import styled from 'styled-components';
import { Button } from 'components';
import { colorVariables } from 'theme/variables';
import mediaQueries from './mediaQueries';

export const SettingsBarStyled = styled.div`
  position: relative;
`;

export const ListsWrap = styled.div`
  position: absolute;
  z-index: 3;
  min-width: 200px;
  bottom: 55px;
  right: -10px;

  &:after {
    content: '';
    position: absolute;
    right: 20px;
    bottom: -20px;
    border: 10px solid transparent;
    border-top: 10px solid ${colorVariables.gray_cod};
    z-index: 3;
    ${mediaQueries};
  }
`;

export const ListWrap = styled.div`
  position: relative;
  min-width: 200px;
  height: 100%;
  background-color: ${colorVariables.gray_cod};
`;

export const List = styled.div`
  position: relative;
  padding: 0;
  margin: 0;
  height: 100%;
  list-style-type: none;
`;

export const StyledButton = styled(Button)`
  && {
    padding: 8px;
  }
`;
